import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { fetchMarketplaceCommunitiesByOrderIdConfig } from 'modals/ShiftModal/src/views/SendToAgenciesView/SelectAgenciesView/contexts/constants';
import { useSSFBehaviors } from 'hooks';
import { SSFBehaviorsContextType } from 'hooks/useSSFBehaviors/useSSFBehaviors.types';
import { FC, useContext, useMemo } from 'react';
import { SendToSelectedAgenciesFetchMarketplaceCommunitiesByOrderIdQuery } from 'types/graphql';
import { createGQLDataContext } from 'utils/createDataContext';

interface IFetchMarketplaceCommunitiesByOrderIdData {}

export const FetchMarketplaceCommunitiesByOrderIdDataContext =
  createGQLDataContext<IFetchMarketplaceCommunitiesByOrderIdData>({});

export const FetchMarketplaceCommunitiesByOrderIdDataProvider: FC = ({ children }) => {
  const { data } = useShiftModalDataContext();
  const order = data?.order;
  const orderId = order?.relayId ?? '';

  const [values, rest] = useSSFBehaviors(
    fetchMarketplaceCommunitiesByOrderIdConfig({
      orderId,
    }),
  );

  const contextValue = useMemo(() => ({ values, ...rest }), [rest, values]);

  return (
    <FetchMarketplaceCommunitiesByOrderIdDataContext.Provider value={contextValue}>
      {children}
    </FetchMarketplaceCommunitiesByOrderIdDataContext.Provider>
  );
};

export const useFetchMarketplaceCommunitiesByOrderIdDataContext =
  (): SSFBehaviorsContextType<SendToSelectedAgenciesFetchMarketplaceCommunitiesByOrderIdQuery> =>
    useContext(FetchMarketplaceCommunitiesByOrderIdDataContext);
